import { render, staticRenderFns } from "./MiscUserSettings.vue?vue&type=template&id=488e81cb&scoped=true&"
import script from "./MiscUserSettings.vue?vue&type=script&lang=js&"
export * from "./MiscUserSettings.vue?vue&type=script&lang=js&"
import style0 from "./MiscUserSettings.vue?vue&type=style&index=0&id=488e81cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488e81cb",
  null
  
)

export default component.exports